<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <basin-timeframe-picker
    [formControl]="formControl"
    [formlyAttributes]="field"
    [styleClass]="this.props.styleClass"
    [style]="this.props.style"
    [inline]="this.props.inline ?? false"
    [autoZIndex]="this.props.autoZIndex ?? true"
    [baseZIndex]="this.props.baseZIndex ?? 0"
    [appendTo]="this.props.appendTo"
    [showOnFocus]="this.props.showOnFocus ?? true"
    [focusTrap]="this.props.focusTrap ?? true"
    [readonly]="props.readonly"
    (onBlur)="blurHandler($event)"
  ></basin-timeframe-picker>
</span>
